import React from "react";
import wordpress from "../assets/images/6.png";
import bootstrap from "../assets/images/2.png";
import javascript from "../assets/images/3.png";
import laravel from "../assets/images/1.png";
import php from "../assets/images/4.png";
import html from "../assets/images/html.png";
import css from "../assets/images/css.png";
import scss from "../assets/images/sass.png";
import react from "../assets/images/5.png";
import shopify from "../assets/images/7.png";

const Resume = () => {
  return (
    <>
      {/* <!-- ====================================== Section Education Experience ===================================== --> */}
      <section className="education-experience" id="resume">
        <div className="row">
          <div className="col-xxl-6 col-lg-6">
            <div className="heading-container">
              <h2 className="section-heading-text about-me fade_up">
                Education.
              </h2>
              <div className="line"></div>
            </div>
            <div className="education position-relative fade_up">
              <div className="side_circle_ring">
                <div className="small_yellow_border">
                  <div className="small_yellow_circle"></div>
                </div>
              </div>
              <div className="small_yellow_border_main">
                <p className="bachelor">Bachelor in Computer Application</p>
                <p className="cursus university">
                  Guru Nanak dev University Amritsar / 2019 - 2022
                </p>
                <p className="cursus">
                  Bachelor in Computer Application, Guru Nanak Dev University Amritsar (2019-2022). Comprehensive three-year undergraduate degree in programming, software development, and IT fundamentals.
                </p>
              </div>
            </div>
            <div className="education position-relative fade_up">
              <div className="side_circle_ring">
                <div className="small_yellow_border">
                  <div className="small_yellow_circle"></div>
                </div>
              </div>
              <div className="small_yellow_border_main">
                <p className="bachelor">HIGH SCHOOL</p>
                <p className="cursus university">
                  Multipurpose Goverment School / 2018
                </p>
                <p className="cursus">
                  Multipurpose Government School, Non-Medical stream (2018). Senior secondary education in science subjects, building strong foundation for technical and engineering career paths.
                </p>
              </div>
            </div>
          </div>
          <div className="col-xxl-6 col-lg-6">
            <div className="heading-container">
              <h2 className="section-heading-text about-me fade_up">
                Experience.
              </h2>
              <div className="line"></div>
            </div>
            <div className="education position-relative fade_up">
              <div className="side_circle_ring">
                <div className="small_yellow_border">
                  <div className="small_yellow_circle"></div>
                </div>
              </div>
              <div className="small_yellow_border_main">
                <p className="bachelor">SENIOR WEB DEVELOPER</p>
                <p className="cursus university">DIGITAL DARZEE / SOFTWARE DARZEE / 2024 - Current</p>
                <p className="cursus">
                  Senior Web Developer at Digital Darzee/Software Darzee (2024-Current). Advanced role developing comprehensive web solutions, leading projects, and utilizing modern technologies for innovative digital experiences.
                </p>
              </div>
            </div>
            <div className="education position-relative fade_up">
              <div className="side_circle_ring">
                <div className="small_yellow_border">
                  <div className="small_yellow_circle"></div>
                </div>
              </div>
              <div className="small_yellow_border_main">
                <p className="bachelor">Junior Web Developer</p>
                <p className="cursus university">W3SOLS 2023 - 2024</p>
                <p className="cursus">
                  Junior Web Developer at W3SOLS (2023-2024). One-year professional experience developing websites, implementing frontend/backend solutions, and gaining hands-on expertise in web technologies.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- ====================================== Section Education Experience End ===================================== --> */}

      {/* <!-- ====================================== Section Design Skill ===================================== --> */}
      <section className="design-skill-section">
        <div className="heading-container">
          <h2 className="section-heading-text design-skill-text fade_up">
            Development Skills.
          </h2>
          <div className="line"></div>
        </div>
        <div className="design-skill-sub-section">
          <div className="design-skills-img-main html flip_up">
            <img src={html} alt="html" />
            <div className="skill-counter-main html-text">

              <p>HTML</p>
            </div>
          </div>
          <div className="design-skills-img-main css flip_up">
            <img src={css} alt="html" />
            <div className="skill-counter-main css-text">

              <p>CSS</p>
            </div>
          </div>
          <div className="design-skills-img-main scss flip_up">
            <img src={scss} alt="scss" />
            <div className="skill-counter-main scss-text">
              <p>SCSS</p>
            </div>
          </div>
          <div className="design-skills-img-main photoshop flip_up">
            <img src={wordpress} alt="wordpress" />
            <div className="skill-counter-main photoshop-text">
              <p>Worpdress</p>
            </div>
          </div>
          <div className="design-skills-img-main adobe-xd flip_up">
            <img src={bootstrap} alt="bootstrap" />
            <div className="skill-counter-main adobe-xd-text">
              <p>Bootstrap</p>
            </div>
          </div>

          <div className="design-skills-img-main sketch flip_up">
            <img src={javascript} alt="javascript" />
            <div className="skill-counter-main sketch-text">
              <p>JavaScript</p>
            </div>
          </div>
          <div className="design-skills-img-main invision flip_up">
            <img src={php} alt="php" />
            <div className="skill-counter-main invision-text">
              <p>PHP</p>
            </div>
          </div>
          <div className="design-skills-img-main laravel flip_up">
            <img src={laravel} alt="laravel" />
            <div className="skill-counter-main laravel-text">
              <p>Laravel</p>
            </div>
          </div>
          <div className="design-skills-img-main react flip_up">
            <img src={react} alt="react" />
            <div className="skill-counter-main react-text">
              <p>React</p>
            </div>
          </div>
          <div className="design-skills-img-main shopify flip_up">
            <img src={shopify} alt="shopify" />
            <div className="skill-counter-main shopify-text">
              <p>Shopify</p>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- ====================================== Section Coding Skill End ===================================== --> */}
    </>
  );
};
export default Resume;
